<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "CategoryList" });
import * as API from "../../services/api.js";
import { CATEGORY_STORE, CATEGORY_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $CATEGORY_HASH;
const syncFromGlobalStore = (data) => {
    const CATEGORIES = get(STORE).map((category) => {
        const KEY = category._.key;
        if (!(KEY in data)) {
            return category;
        }
        return data[KEY];
    });
    STORE.set(CATEGORIES);
};
const setStore = (categories) => {
    STORE.set(categories);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterCategories({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onCategoryHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $CATEGORY_HASH;
    isLoading = true;
    void API.filterCategories({ ...parameters }).then(setStore);
};
$: onCategoryHashChange($CATEGORY_HASH);
onMount(() => {
    unsubscribe = CATEGORY_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot categories = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}